A public draft position profile for the enhanced job posting panel.
